const { cloneDeep, some } = require('lodash');
const executor = require('./query-executor');
const shouldClearValues = async (conditions, values) => {
    if(conditions?.length === 0) {
        return false;
    }
    
    //Make sure we aren't looking at a condition for required fields
    const conditionsWeCareAbout = (conditions || []).filter(c => c.effect === 'show' || c.effect === 'hide');
    
    const conditionsMet = await metConditions(conditionsWeCareAbout, values);
    const clearIfMet = conditionsWeCareAbout?.[0]?.effect === 'hide';
    return (conditionsMet && clearIfMet) || (!conditionsMet && !clearIfMet);
}

const metConditions = async (conditions, values) => {
    if (conditions.length === 0) {
        return true;
    }
    const results = await Promise.all(conditions.map(condition => {
        return new Promise(resolve => {
            const fn = condition.fn || executor(condition.query);
            fn(values).then(resolve);
        });
    }));
    return some(results);
};
const clearValuesForUnmetConditions = async (template, incomingValues) => {
    const values = cloneDeep(incomingValues);
    if (!template || !template.pages || !values) {
        return values;
    }
    await Promise.all(template.pages.map(async page => {
        let pageWasDeleted = false;
        let conditions = page.conditions || [];
        if (await shouldClearValues(conditions, values)) {
            pageWasDeleted = true;
            delete values[page.id];
        }
        if (!pageWasDeleted) {
            const sections = page.sections || [];
            await Promise.all(sections.map(async section => {
                let sectionWasDeleted = false;
                let conditions = section.conditions || [];
                const groups = section.groups || [];
                if (await shouldClearValues(conditions, values)) {
                    sectionWasDeleted = true;
                    const questionIds = groups.reduce((memo, group) => {
                        const questions = group.questions || [];
                        const ids = questions.map(it => it.id);
                        return [].concat(memo, ids);
                    }, []);
                    questionIds.forEach(id => {
                        if (values[page.id]) {
                            delete values[page.id][id];
                        }
                    });
                }
                if (!sectionWasDeleted) {
                    const questions = groups.reduce((memo, group) => [].concat(memo, group.questions || []), []);
                    await Promise.all(questions.map(async question => {
                        let conditions = question.conditions || [];
                        if (values[page.id] && await shouldClearValues(conditions, values)) {
                            delete values[page.id][question.id];
                        }
                    }));
                }
            }));
        }
        Object.keys(values).forEach(key => {
            if (Object.keys(values[key]).length === 0) {
                delete values[key];
            }
        });
        return Promise.resolve(true);
    }));
    return values;
};
module.exports = clearValuesForUnmetConditions;
